<template>
    <div>
        <v-btn dark outlined class="body-1 px-10 main--yellow test-white caption mb-4" depressed @click="personalEdit = true">{{ $t('edit') }}</v-btn>
        <v-dialog
                v-model="personalEdit"
                width="600"
                hide-overlay
                transition="dialog-bottom-transition"
        >
            <v-toolbar
                    flat
                    dark
                    class="main--yellow"
            >
                <v-spacer></v-spacer>
                <v-toolbar-items>
                   <v-spacer></v-spacer>
                    <v-btn text @click.native="personalEdit = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card>
                <div class="d-flex justify-center title pa-4 text-center">{{ $t('personalInfoSettings') }}</div>
                <v-card-text>
                    <div class="title">{{ $t('myInfo') }}</div>
                    <v-row сlass="pb-4">
                        <v-col cols="12" xs="12" sm="4">
                            <v-text-field
                                    :label="$t('firstName')"
                                    v-model="profileModel.firstName"
                                    color="orange lighten-2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="4">
                            <v-text-field
                                    :label="$t('lastName')"
                                    v-model="profileModel.lastName"
                                    color="orange lighten-2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <div class="title">{{ $t('contacts') }}</div>
                    <v-row сlass="pb-4">
                        <v-col cols="12" xs="12" sm="4">
                            <geo-search :geo="profileModel.geo" @geo-change="geoChange"></geo-search>
                        </v-col>
                        <v-col cols="12" xs="12" sm="4">
                            <v-text-field
                                    label="Email"
                                    v-model="profileModel.email"
                                    color="orange lighten-2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="4">
                            <v-text-field
                                    v-if="profileModel.phone"
                                    :label="$t('phoneNumber')"
                                    v-model="profileModel.phone.clear"
                                    color="orange lighten-2"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <div class="title">Статус</div>
                    <v-row сlass="pb-4">
                        <!--<v-col cols="12" md="6">
                            <v-switch :label="$t('buyer')" color="orange" v-model="profileModel.isBuyer"></v-switch>
                            <v-switch :label="$t('seller')" color="orange" v-model="profileModel.isSeller"></v-switch>
                        </v-col>-->
                        <v-col cols="12" md="6">
                            <v-switch :label="$t('physical')" color="orange" v-model="profileModel.isPhysical" @change="statusChange('isPhysical')"></v-switch>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-switch :label="$t('law')" color="orange" v-model="profileModel.isLaw" @change="statusChange('isLaw')"></v-switch>
                        </v-col>
                    </v-row>
                </v-card-text>
                <div class="d-flex justify-center pb-6">
                    <v-btn depressed dark color="main--yellow" @click="saveChanges">
                        {{ $t('save') }}
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
        <snack-general :snack-data="snackData"></snack-general>
    </div>
</template>

<script>
    import GeoSearch from '../../../general/geo/search';
    import ProfileUpdate from '../../mixins/ProfileUpdate';
    import SnackGeneral from '../snacks/SnackGeneral';

    export default {
        name: "PersonalEdit",
        mixins:[ProfileUpdate],
        components:{SnackGeneral, GeoSearch},
        data(){
            return {
                personalEdit: false,
                profileModel: {
                    firstName: null,
                    lastName: null,
                    company: {},
                    geo: {},
                    email: null,
                    phone: {},
                    isBuyer: false,
                    isLaw: false,
                    isPhysical: false,
                    isSeller: false,
                },
                isLoadingGeo: false,
                geoSearch: null,
                snackData: {
                    isOpen: false,
                    color: '',
                    text: ''
                }
            }
        },
        computed: {
            company() {
                return this.profileData.company;
            },
            profileData() {
                return this.$store.state.account.profileData;
            }
        },
        methods: {
            geoChange(geo) {
                this.profileModel.geo = {
                    name: geo.name,
                    id: geo.id
                };
            },
            saveChanges(){
                this.saveProfileData(this.profileModel)
                    .then(res => {
                        if(res.data.profileData) {
                            this.updateStoreProfile(res.data.profileData);
                        }

                        this.snackHandle(this.$t('changesSaved'), 'main--black', true)
                    })
                    .catch(err => {
                        this.snackHandle(this.$t('changesSavedError'), 'error', true)
                    });
                this.personalEdit = false;
            },
            setProfileModel(){
                this.profileModel = {
                    firstName: this.profileData.firstName,
                    lastName: this.profileData.lastName,
                    company: this.company,
                    geo: this.profileData.geo,
                    id: this.profileData.id,
                    email: this.profileData.email,
                    phone: this.profileData.phone,
                    isBuyer: this.profileData.isBuyer,
                    isSeller: this.profileData.isSeller,
                    isLaw: this.profileData.isLaw,
                    isPhysical: this.profileData.isPhysical,
                };
            },
            snackHandle(text, color, isOpen) {
                this.snackData.color = color;
                this.snackData.text = text;
                this.snackData.isOpen = isOpen;
            },
            statusChange(status){
                if(status === 'isLaw') {
                    if (this.profileModel.isLaw) {
                        this.profileModel.isPhysical = false;
                    }
                }

                if(status === 'isPhysical') {
                    if (this.profileModel.isPhysical) {
                        this.profileModel.isLaw = false;
                    }
                }
            }
        },
        created(){
            this.setProfileModel();
        },
        watch: {
            profileData(){
                this.setProfileModel();
            }
        }
    }
</script>

<style scoped>

</style>
